export enum TherapielandTreatmentCategory {
    kindJeugd = 'Kind & Jeugd',
    lvb = 'LVB',
    volwassenen = 'Volwassenen',
}
